"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=item.js.map


// WEBPACK FOOTER //
// /static/node_modules/@ridi/event-client/dist/cjs/models/item.js